import React, { useEffect, useState } from "react";
import {
  CancelButton,
  UpdateButton,
} from "../../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Box, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  getAllCategory,
  getCategoryTypesNoLimit,
  updateCategory,
} from "../../../redux/features/assetManagementSlice";
import AddType from "../Type/AddType";
import Loader3D from "../../../components/Loader/Loader3D";

const EditCategory = ({ rowData, dispatchParams }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading, categoryTypesNoLimit } = useSelector(
    (state) => state.assetmanagement
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      category_id: rowData.category_id,
      category_name: rowData.category_name,
      category_description: rowData.category_description,
      category_type: rowData.category_type,
      sub_category: [
        { sub_category_name: "", sub_category_prefix: "" }, // Start with one row
      ],
    },
    onSubmit: (values) => {
      dispatch(updateCategory({ data: [values] })).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getAllCategory(dispatchParams));
          setOpen(false);
          formik.resetForm();
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  useEffect(() => {
    if (open) {
      dispatch(getCategoryTypesNoLimit());
    }
  }, [open]);

  return (
    <GlobalDialog
      title={"Update Category"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      popupButton={
        <UpdateButton size="medium" action={() => setOpen(true)}>
          Update
        </UpdateButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              {loading && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    bgcolor: "rgba(255,255,255,0.6)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 10,
                  }}
                >
                  <Loader3D />
                </Box>
              )}
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <TextField
                    name="category_name"
                    value={formik.values.category_name}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Category Name"
                  />
                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}
                  >
                    <AddType />
                  </Box>
                  <GlobalSelectField
                    options={{
                      formik,
                      name: "category_type",
                      label: "Type",
                      data: categoryTypesNoLimit,
                      keys: {
                        id: "category_type_id",
                        value: "category_type_name",
                      },
                    }}
                  />
                  <TextField
                    name="category_description"
                    value={formik.values.category_description}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Description"
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <UpdateButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Update"}
                    </UpdateButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default EditCategory;
